// extracted by mini-css-extract-plugin
export var banner = "_1o-0";
export var icon = "_1o-1";
export var message = "_1o-2";